/**
 * @generated SignedSource<<4414790de0cb758cb169833b478990cd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type datasetVersionCitationFragment$data = {
  readonly dataset: {
    readonly localSlug: string;
    readonly name: string;
    readonly owner: {
      readonly username: string;
    };
    readonly shortDescription: string | null | undefined;
  };
  readonly doi: {
    readonly full: string;
  } | null | undefined;
  readonly license: string | null | undefined;
  readonly publishedAt: DateTime | null | undefined;
  readonly version: Semver;
  readonly " $fragmentType": "datasetVersionCitationFragment";
};
export type datasetVersionCitationFragment$key = {
  readonly " $data"?: datasetVersionCitationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"datasetVersionCitationFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "datasetVersionCitationFragment"
};

(node as any).hash = "d4eaa8ddd477559f628fb08e614817ea";

export default node;
